"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledPaginationJumpItem = void 0;
var _PaginationJumpItem = require("./PaginationJumpItem");
// TODO: in v9, move styled() from PaginationJumpItem.jsx to here
var StyledPaginationJumpItem = _PaginationJumpItem.PaginationJumpItem;
exports.StyledPaginationJumpItem = StyledPaginationJumpItem;